import RankingReportEdit from './RankingReportEdit';

export default { Edit: RankingReportEdit };
